// admin/* 페이지 번역
const admin = {
  index: {
    title: '관리자 페이지',
    subtitle: '회사 및 데이터 관리',
    tab: {
      company: '회사 관리',
      data: '데이터 확인',
    },
  },
  companyManagement: {
    statusLabel: '상태',
    statusAll: '전체',
    statusActive: '활성',
    statusInactive: '비활성',
    searchPlaceholder: '회사명 또는 코드 검색',
    addBtn: '회사 추가',
    col: {
      name: '회사명',
      code: '회사코드',
      ceo: '대표이사',
      businessNumber: '사업자번호',
      address: '주소',
      phone: '연락처',
      employees: '직원수',
      status: '상태',
      createdDate: '등록일',
      action: '작업',
    },
    employeesSuffix: '{n}명',
    stats: {
      total: '전체 회사',
      active: '활성',
      inactive: '비활성',
      employees: '총 직원수',
    },
    deleteModal: {
      title: '회사 삭제 확인',
      messagePrefix: '회사를 삭제하시겠습니까?',
      submessage: '이 작업은 되돌릴 수 없습니다.',
      cancel: '취소',
      confirm: '삭제',
    },
  },
  companyRegister: {
    title: '회사 등록',
    subtitle: '새로운 회사 정보를 등록합니다',
    sectionBasic: '기본 정보',
    sectionContact: '연락 정보',
    sectionOperation: '운영 정보',
    fields: {
      name: '회사명',
      code: '회사코드',
      ceo: '대표이사',
      businessNumber: '사업자번호',
      address: '주소',
      phone: '연락처',
      employees: '직원수',
      status: '상태',
    },
    placeholder: {
      name: '회사명을 입력하세요',
      code: '회사코드를 입력하세요',
      ceo: '대표이사명을 입력하세요',
      businessNumber: '123-81-00998',
      address: '주소를 입력하세요',
      phone: '031-200-1114',
      employees: '직원수를 입력하세요',
    },
    statusActive: '활성',
    statusInactive: '비활성',
    cancel: '취소',
    submit: '등록',
    error: {
      nameRequired: '회사명을 입력해주세요',
      codeRequired: '회사코드를 입력해주세요',
      ceoRequired: '대표이사를 입력해주세요',
      businessNumberRequired: '사업자번호를 입력해주세요',
      businessNumberInvalid: '사업자번호 형식이 올바르지 않습니다 (예: 123-81-00998)',
      addressRequired: '주소를 입력해주세요',
      phoneRequired: '연락처를 입력해주세요',
      phoneInvalid: '연락처 형식이 올바르지 않습니다 (예: 031-200-1114)',
      employeesRequired: '직원수를 입력해주세요',
      employeesInvalid: '유효한 직원수를 입력해주세요',
    },
  },
  companyDetail: {
    title: '회사 상세 정보',
    subtitle: '회사 정보 조회 및 수정',
    delete: '삭제',
    edit: '수정',
    cancel: '취소',
    save: '저장',
    profile: {
      codeLabel: '회사코드: {code}',
      registeredOn: '등록일',
      employees: '직원수',
    },
    sectionBasic: '기본 정보',
    sectionContact: '연락 정보',
    sectionOperation: '운영 정보',
    fields: {
      name: '회사명',
      code: '회사코드',
      ceo: '대표이사',
      businessNumber: '사업자번호',
      address: '주소',
      phone: '연락처',
      employees: '직원수',
      status: '상태',
      createdDate: '등록일',
    },
    statusActive: '활성',
    statusInactive: '비활성',
    employeesSuffix: '{n}명',
    confirmDelete: '정말로 이 회사를 삭제하시겠습니까?',
  },
  dataVerification: {
    placeholder: '개발 예정',
  },
};

export default admin;
